import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a minor error that we can ignore
    const errorMessage = error?.message || '';
    const ignorableErrors = [
      'removeChild',
      'insertBefore',
      'NotFoundError',
      'Script error',
      'ChunkLoadError',
      'Loading chunk',
      'Network Error'
    ];
    
    if (ignorableErrors.some(e => errorMessage.includes(e)) || error?.name === 'NotFoundError') {
      console.warn('Suppressed error:', errorMessage);
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const errorMessage = error?.message || '';
    const ignorableErrors = [
      'removeChild',
      'insertBefore',
      'NotFoundError',
      'Script error',
      'ChunkLoadError'
    ];
    
    // Log error but don't crash for minor errors
    if (ignorableErrors.some(e => errorMessage.includes(e)) || error?.name === 'NotFoundError') {
      console.warn('Caught and suppressed error:', error);
      // Reset state to allow app to continue
      this.setState({ hasError: false, error: null });
      return;
    }
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-md text-center">
            <h2 className="text-xl font-bold text-red-600 mb-4">Algo salió mal</h2>
            <p className="text-gray-600 mb-4">Por favor recarga la página</p>
            <button 
              onClick={() => window.location.reload()}
              className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
